import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Target, Users } from 'lucide-react';
import { Card, CardContent } from './ui/card';

const About = () => {
  const { t } = useLanguage();

  return (
    <section id="about" className="py-24 bg-transparent">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-100 mb-4">
            {t.about.title}
          </h2>
          {t.about.subtitle && (
            <p className="text-lg text-slate-300 max-w-2xl mx-auto">
              {t.about.subtitle}
            </p>
          )}
        </div>

        {/* About Content */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-16">
          {/* Text Content */}
          <div className="space-y-6">
            <p className="text-lg text-slate-300 leading-relaxed whitespace-pre-line">
              {t.about.description}
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 pt-6">
              <div className="text-center p-6 bg-gradient-to-br from-slate-900/80 to-slate-900/40 rounded-xl border border-cyan-500/20">
                <div className="text-4xl font-bold text-cyan-300 mb-2">20+</div>
                <div className="text-sm text-slate-300 font-medium">Progetti Completati</div>
              </div>
              <div className="text-center p-6 bg-gradient-to-br from-slate-900/80 to-slate-900/40 rounded-xl border border-cyan-500/20">
                <div className="text-4xl font-bold text-teal-300 mb-2">6+</div>
                <div className="text-sm text-slate-300 font-medium">anni di Esperienza</div>
              </div>
            </div>
          </div>

          {/* Visual Element */}
          <div className="relative">
            <div className="aspect-square bg-gradient-to-br from-slate-900 via-cyan-900/40 to-slate-950 rounded-2xl overflow-hidden border border-cyan-500/20">
              <div className="w-full h-full flex items-center justify-center">
                <div className="text-center p-8">
                  <div className="w-32 h-32 mx-auto mb-6 bg-gradient-to-br from-cyan-400 to-teal-500 rounded-full flex items-center justify-center shadow-2xl shadow-cyan-500/30">
                    <span className="text-5xl font-bold text-slate-950">MD</span>
                  </div>
                  <p className="text-2xl font-bold text-slate-100">molelabs</p>
                  <p className="text-slate-300 mt-2">Digital Innovation Studio</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Mission & Approach Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <Card className="border-cyan-500/20 bg-slate-900/60 hover:shadow-lg hover:shadow-cyan-500/10 transition-shadow duration-300">
            <CardContent className="p-8">
              <div className="mb-4">
                <div className="w-12 h-12 bg-gradient-to-br from-cyan-400 to-teal-500 rounded-lg flex items-center justify-center shadow-lg shadow-cyan-500/30">
                  <Target className="w-6 h-6 text-slate-950" />
                </div>
              </div>
              <h3 className="text-2xl font-bold text-slate-100 mb-3">
                {t.about.mission}
              </h3>
              <p className="text-slate-300 leading-relaxed">
                {t.about.missionText}
              </p>
            </CardContent>
          </Card>

          <Card className="border-cyan-500/20 bg-slate-900/60 hover:shadow-lg hover:shadow-cyan-500/10 transition-shadow duration-300">
            <CardContent className="p-8">
              <div className="mb-4">
                <div className="w-12 h-12 bg-gradient-to-br from-cyan-400 to-teal-500 rounded-lg flex items-center justify-center shadow-lg shadow-cyan-500/30">
                  <Users className="w-6 h-6 text-slate-950" />
                </div>
              </div>
              <h3 className="text-2xl font-bold text-slate-100 mb-3">
                {t.about.approach}
              </h3>
              <p className="text-slate-300 leading-relaxed">
                {t.about.approachText}
              </p>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default About;
